<template>
    <NoteModal
        :note-text="noteText"
        :added-by="addedBy"
        :date="date"
        @close="$emit('abort')"
    />
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import NoteModal from '@/modules/entity-notes/components/NoteModal/NoteModal.vue';

    // PRODUCT-26110 QA fixes4: declares the `abort` event this procedure component
    // `$emit`s -- without a declared `emits`, Vue 3 warns "Component emitted event
    // 'abort' but it is neither declared in the emits option nor as an 'onAbort' prop"
    // every time it fires.
    export default defineComponent({
        name: 'ViewNoteProcedure',
        components: { NoteModal },
        props: {
            // PRODUCT-26110 QA fixes4: `uuid` is unused; declared purely so Vue 3 doesn't
            // warn "Extraneous non-props attributes (uuid)" (see
            // UploadEntityDocumentProcedure.vue).
            uuid: {
                type: String,
                default: '',
            },
            noteText: {
                type: String as PropType<string | null>,
                required: true,
            },
            addedBy: {
                type: String as PropType<string>,
                required: true,
            },
            date: {
                type: String as PropType<string>,
                required: true,
            },
        },
        emits: [ 'abort' ],
    });
</script>
